import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import ReCAPTCHA from "react-google-recaptcha";
import { blogListForWebsite } from "../../../Services/Blog/BlogApi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import SuccessPopupModal from "../../components/SuccessPopupModal";
import { addUpdateEnquiry } from "../../../Services/EnqueryApi";

const AerialSurey = () => {
  const [count, setCount] = useState(0);
  const [showPreloader, setShowPreloader] = useState(true);
  const [modelAction, setModelAction] = useState([]);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { setLoader, user } = useAuth();
  const [totalRecords, setTotalRecords] = useState(-1);
  const [totalPage, setTotalPage] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(30);
  const [blogListData, setBlogListData] = useState([]);

  const [captchaToken, setCaptchaToken] = useState(null);
  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };

  //  const [bannerSlides,setBannerSlides]=useState([])

  const [error, setErrors] = useState(null);
  const [errorMessage, setErrorMessage] = useState();

  const [homeContactObj, setHomeContactObj] = useState({
    name: null,
    phoneNumber: null,
    message: null,
    email: null,
  });

  // useEffect(() => {
  //   GetWebsiteBlogListData(1, null);
  // }, []);

  const AddStateBtnClick = async () => {
    let isValid = false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      homeContactObj.firstName === null ||
      homeContactObj.firstName === undefined ||
      homeContactObj.firstName === "" ||
      homeContactObj.lastName === null ||
      homeContactObj.lastName === undefined ||
      homeContactObj.lastName === "" ||
      homeContactObj.phoneNumber === null ||
      homeContactObj.phoneNumber === undefined ||
      homeContactObj.phoneNumber === "" ||
      homeContactObj.phoneNumber?.length < 10 ||
      homeContactObj.message === null ||
      homeContactObj.message === undefined ||
      homeContactObj.message === "" ||
      homeContactObj.email === null ||
      homeContactObj.email === undefined ||
      !emailRegex.test(homeContactObj.email) ||
      homeContactObj.email === ""
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
      firstName: homeContactObj.firstName,
      message: homeContactObj.message,
      email: homeContactObj.email,
      phoneNumber: homeContactObj.phoneNumber,
      pageName: "header",
      serviceID: null,
      enquiryKeyID: null,
      lastName: homeContactObj.lastName,
    };

    if (!isValid) {
      AddUpdateStateData(apiParam);
    }
  };

  const AddUpdateStateData = async (apiParam) => {
    try {
      let url = "/addUpdateEnquiry"; // Default URL for Adding Data

      const response = await addUpdateEnquiry(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          // setLoader(false);
          setShowSuccessModal(true);
          setModelAction("Enquiry Sent Successfully!"); //Do not change this naming convention
          setInitialData();
          // setIsAddUpdateActionDone(true);
        } else {
          // setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      //   setLoader(false);
      console.error(error);
    }
  };

  // useEffect(()=>{
  //   GetBannerListForWebsiteData()
  // },[])

  // const GetBannerListForWebsiteData = async () => {

  //   try {
  //     const data = await bannerListForWebsite();
  //     if (data?.data?.statusCode === 200) {
  //       setLoader(false);

  //       const rawData = data.data.responseData?.data || [];

  //       const formattedSlides = rawData.map((item) => ({
  //         id: item.BannerKeyID,
  //         title: item.BannerTitle || "",
  //         subtitle: item.BannerSubTitle || "",
  //         description: "", // Add if needed
  //         bgClass: "", // Optional styling class
  //         buttons: [], // Fill if your API has button data,
  //         image: item.BannerImage || "", // optional // You may need to confirm mime type (jpeg/png)

  //       }));

  //       setBannerSlides(formattedSlides);

  //     } else {
  //       setLoader(false);
  //       // Handle non-200 status codes if necessary
  //       console.error('Error fetching data: ', data?.data?.statusCode);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.error('Error in Customer : ', error);
  //   }
  // };

  const setInitialData = () => {
    setHomeContactObj({
      ...homeContactObj,
      firstName: "",
      lastName: "",
      phoneNumber: "",
      message: "",
      email: "",
    });
    setErrors(false); // Reset error flag too
    setErrorMessage(false); // Optional if you're using this for custom messages
  };

  const closeAllModal = () => {
    setShowSuccessModal(false);
  };

  const getBreadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.big-strategic.com/",
      },
    ],
  };

  const getOrganizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Techno Land - Engineers & Surveyors",
    alternateName: "BIG Strategic Management Consultants",
    url: "https://www.big-strategic.com/",
    logo: "https://www.big-strategic.com/assets/img/logo/footer-new.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91 7304502790",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: ["en", "Hindi"],
    },
  };

  const getWebPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Business Growth Strategies – BIG Strategic Management Consultants",
    url: "https://www.big-strategic.com/",
    description:
      "Get expert business consulting with BIG Strategic Management Consultants. We blend experience & innovation to drive success across industries worldwide. Let’s grow together.",
    publisher: {
      "@type": "Organization",
      name: "BIG Strategic",
    },
  };

  const getLocalBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "BIG Strategic Management Consultants",
    image: "https://www.big-strategic.com/assets/img/logo/footer-new.png",
    "@id": "",
    url: "https://www.big-strategic.com/",
    telephone: "+91 7304502790",
    address: {
      "@type": "PostalAddress",
      streetAddress: "A321, Lodha Supremus 2, Wagle Estate Road No.22",
      addressLocality: "400604",
      postalCode: "400604",
      addressCountry: "IN",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "09:00",
      closes: "18:00",
    },
  };

  const navigate = useNavigate();

  const GetWebsiteBlogListData = async (pageNumber, searchKeywordValue) => {
    setLoader(true);
    try {
      const data = await blogListForWebsite({
        pageSize,
        pageNo: pageNumber - 1, // Page numbers are typically 0-based in API calls
        searchKeyword:
          searchKeywordValue === undefined ? searchKeyword : searchKeywordValue,
      });

      if (data) {
        if (data?.data?.statusCode === 200) {
          setLoader(false);
          if (data?.data?.responseData?.data) {
            const MasterStateListData = data.data.responseData.data;
            const totalItems = data.data?.totalCount; // const totalItems = 44;
            setTotalCount(totalItems);
            const totalPages = Math.ceil(totalItems / pageSize);
            setTotalPage(totalPages);
            setTotalRecords(MasterStateListData.length);
            setBlogListData(MasterStateListData);
          }
        } else {
          setErrorMessage(data?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Aerial Survey Service In India



        </title>
        <meta
          name="description"
          content="Get precise aerial surveys in India using drones. We provide detailed maps, 3D models, and land data for construction, agriculture, and planning.
"
        />
      </Helmet>
      <div
        class="rts-banner-area rts-section-gap rts-breadcrumb-area  position-relative contact-bd header-banner"
        style={{ height: "570px" }}
      >
        <div class="container">
          <div class="rts-contact-area-page rts-section-gap">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6 pr--60 pr_sm--0 mb_sm--30 pr_md--10 pb_md--25 pb_sm--25">
                  <div class="contact-main-wrapper-left">
                    <h1
                      className="title-main new-servicehead"
                      style={{ color: "white", fontSize: "40px" }}
                    >
                      Aerial Survey Service{" "}
                      <span style={{ color: "#ef2830" }}> in India</span>
                    </h1>
                    <p class="disc" style={{ color: "white", marginBottom: "7px" }}>
                      Aerial survey uses advanced drone technology to capture precise images and data of land, buildings, and terrain. We provide detailed maps, 3D models, and measurements to help you plan construction, monitor projects, and manage land efficiently.</p>
                    <p class="disc" style={{ color: "white", marginTop: "0px" }}>
                      Our expert team delivers fast, accurate, and reliable survey results, making complex planning and decision-making easier for developers, farmers, and businesses across India. We also offer real-time progress monitoring, high-resolution imaging, and customizable survey reports, ensuring every project gets the insights needed for precise execution and effective land management.




                    </p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div id="form-messages"></div>
                  <div
                    class="contact-form-area-wrapper"
                    style={{ padding: "15px" }}
                  >
                    {/* <h4 class="title" style={{marginBottom:'5px',color:'#ef2830'}}>Let’s Get in Touch</h4> */}
                    <div class="half-inpur-wrapper">
                      <div class="single">
                        <input
                          type="text"
                          value={homeContactObj.firstName}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let inputValue = e.target.value;

                            // Remove numbers and special characters, allow only letters and space
                            inputValue = inputValue.replace(/[^a-zA-Z\s]/g, "");

                            // Remove leading spaces
                            inputValue = inputValue.replace(/^\s+/, "");

                            // Capitalize first letter, rest lowercase (optional tweak)
                            inputValue =
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1);

                            setHomeContactObj((prev) => ({
                              ...prev,
                              firstName: inputValue,
                            }));
                          }}
                          placeholder="First Name"
                        />
                        {error &&
                          (homeContactObj.firstName === null ||
                            homeContactObj.firstName === undefined ||
                            homeContactObj.firstName === "") ? (
                          <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="single">
                        <input
                          type="text"
                          value={homeContactObj.lastName}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let inputValue = e.target.value;

                            // Remove numbers and special characters, allow only letters and space
                            inputValue = inputValue.replace(/[^a-zA-Z\s]/g, "");

                            // Remove leading spaces
                            inputValue = inputValue.replace(/^\s+/, "");

                            // Capitalize first letter, rest lowercase (optional tweak)
                            inputValue =
                              inputValue.charAt(0).toUpperCase() +
                              inputValue.slice(1);

                            setHomeContactObj((prev) => ({
                              ...prev,
                              lastName: inputValue,
                            }));
                          }}
                          placeholder="Last Name"
                        />
                        {error &&
                          (homeContactObj.lastName === null ||
                            homeContactObj.lastName === undefined ||
                            homeContactObj.lastName === "") ? (
                          <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                        ) : (
                          ""
                        )}{" "}
                      </div>
                    </div>
                    <div class="half-inpur-wrapper">
                      <div class="single">
                        <input
                          type="email"
                          value={homeContactObj.email}
                          onChange={(e) => {
                            setErrorMessage(false);
                            let InputValue = e.target.value;
                            const updatedValue = InputValue.replace(
                              /[^a-zA-Z0-9\s@&.\-_]/g,
                              ""
                            );
                            setHomeContactObj((prev) => ({
                              ...prev,
                              email: updatedValue,
                            }));
                          }}
                          placeholder="Email"
                        />
                        {error && (
                          <>
                            {homeContactObj.email === null ||
                              homeContactObj.email === undefined ||
                              homeContactObj.email === "" ? (
                              <span style={{ color: "red" }}>
                                {ERROR_MESSAGES}
                              </span>
                            ) : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(
                              homeContactObj.email
                            ) ? (
                              <span style={{ color: "red" }}>
                                Please enter a valid email address.
                              </span>
                            ) : null}
                          </>
                        )}{" "}
                      </div>
                      <div class="single">
                        <input
                          maxLength={10}
                          placeholder=" Contact Number"
                          value={homeContactObj.phoneNumber}
                          onChange={(e) => {
                            setErrorMessage("");
                            const value = e.target.value;
                            let FormattedNumber = value.replace(/[^0-9]/g, ""); // Allows only numbers

                            // Apply regex to ensure the first digit is between 6 and 9
                            FormattedNumber = FormattedNumber.replace(
                              /^[0-5]/,
                              ""
                            );
                            setHomeContactObj((prev) => ({
                              ...prev,
                              phoneNumber: FormattedNumber,
                            }));
                          }}
                        />
                        {error && (
                          <span style={{ color: "red" }}>
                            {homeContactObj.phoneNumber === null
                              ? ERROR_MESSAGES
                              : homeContactObj.phoneNumber?.length < 10
                                ? "Invalid phone number"
                                : ""}
                          </span>
                        )}{" "}
                      </div>
                    </div>
                    <textarea
                      rows="4"
                      value={homeContactObj.message}
                      onChange={(e) => {
                        setErrorMessage(false);
                        let InputValue = e.target.value;
                        const updatedValue = InputValue.replace(
                          /[^a-zA-Z0-9\s@&.\-_]/g,
                          ""
                        );
                        setHomeContactObj((prev) => ({
                          ...prev,
                          message: updatedValue,
                        }));
                      }}
                      placeholder="Your Message"
                    ></textarea>
                    <div className="single">
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={handleCaptcha}
                      />
                    </div>
                    {error &&
                      (homeContactObj.message === null ||
                        homeContactObj.message === undefined ||
                        homeContactObj.message === "") ? (
                      <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                    ) : (
                      ""
                    )}{" "}
                    <button
                      onClick={AddStateBtnClick}
                      class="rts-btn btn-primary"
                      style={{ marginTop: "20px" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              {showSuccessModal && (
                <SuccessPopupModal
                  show={showSuccessModal}
                  onHide={() => closeAllModal()}
                  setShowSuccessModal={setShowSuccessModal}
                  modelAction={modelAction}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        class="about-service-main-wrapper rts-section-gap bg_white"
        id="about"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-5 order-md-1 order-2">
              <div class="thumbnail-main-wrapper-2">
                <div class="reveal-item overflow-hidden aos-init">
                  <div class="" data-aos="reveal-end"></div>
                  <img src="assets/images/about/d1.png" alt="aerial-survey" />
                </div>
              </div>
            </div>
            <div class="col-xl-7 pl--60 pl_md--0 pl_sm--10 pt_md--30 pt_sm--30 order-md-2 order-1">
              <div class="about-content-area-two">
                <div class="title-style-two-left">
                  <div class="title-left-align-five">
                    <h2 class="title mb--30">Why Choose Us</h2>
                  </div>

                  <p class="disc">
                    Our aerial survey services combine advanced drone technology with expert surveyors to deliver precise, reliable, and easy-to-understand results. We help you plan, monitor, and manage land projects efficiently, safely, and affordably.



                  </p>

                  <ul class="subservice-link">
                    <li>Fast and accurate aerial data collection


                    </li>
                    <li>Skilled and licensed survey professionals



                    </li>
                    <li>High‑resolution maps & 3D models



                    </li>
                    <li>Safe operations even in hard terrain



                    </li>
                    <li>Transparent, cost‑friendly pricing


                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rts-offer-area-start rts-section-gap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-style-two-center inner">
                <h2 class="title mb--0">Services We Provide</h2>
                <p className="main mb--40">
                  We offer aerial survey solutions for land, construction, and project planning, helping you make informed decisions with clear visuals and detailed maps.


                </p>
              </div>
            </div>
          </div>
          <div class="row g-24">
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">1. Topographic Mapping
                    </h3>
                  </a>
                  <p class="disc">
                    We create detailed topographic maps using drones to show elevations, slopes, and contours. Perfect for construction planning, land development, and infrastructure projects.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">2. Construction Site Monitoring
                    </h3>
                  </a>
                  <p class="disc">
                    Regular aerial surveys help track construction progress, identify issues, and improve project efficiency. Stay updated with accurate visuals and reports.


                    {" "}
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">3. Land Parcel Survey
                    </h3>
                  </a>
                  <p class="disc">
                    We survey plots, farms, and large land areas from the air. Accurate measurements and maps help you plan and manage your property efficiently.



                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">4. 3D Modeling & Mapping
                    </h3>
                  </a>
                  <p class="disc">
                    Our drones capture high-resolution images to generate 3D models of land, buildings, and terrain. Ideal for architects, engineers, and planners.




                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">5. Agricultural Surveys
                    </h3>
                  </a>
                  <p class="disc">
                    Monitor crop health, irrigation, and soil conditions using aerial data. Improve yield and make informed farm management decisions.


                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div class="single-offer-inner">
                <div class="content-area">
                  <a href="#" class="title">
                    <h3 class="title">6. Environmental & Forestry Surveys</h3>
                  </a>
                  <p class="disc">
                    We capture aerial data of forests, wetlands, and natural resources. Helps with conservation, planning, and environmental assessments.



                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="rts-offer-area-start rts-section-gap testimunal-new"
        style={{ backgroundColor: "white" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-style-two-center inner">
                <h2 class="title mb--40">What Our Clients Say</h2>
              </div>
            </div>
          </div>
          <div class="row g-24">
            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#000000ff" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "white",
                      }}
                    >
                      Ramesh Kumar

                    </p>
                  </a>
                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "white",
                      }}
                    >
                      “
                    </span>
                    Technoland’s aerial survey was precise and fast. Their team helped us plan our construction project perfectly.
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "white",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#ef2830" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "white",
                      }}
                    >
                      {" "}
                      Anita Singh




                    </p>
                  </a>
                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "white",
                      }}
                    >
                      “
                    </span>
                    The drone survey gave us accurate maps of our farmland. It made farm planning much easier.
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "#ffffffff",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-offer-inner"
                style={{ backgroundColor: "#000000ff" }}
              >
                <div class="content-area">
                  <a href="#" class="title">
                    <p
                      class="title"
                      style={{
                        fontSize: "25px",
                        marginBottom: "20px",
                        color: "#ffffffff",
                      }}
                    >
                      Vikram Patel



                    </p>
                  </a>

                  <p class="disc client-content">
                    <span
                      style={{
                        fontSize: "50px",
                        color: "#ffffffff",
                      }}
                    >
                      “
                    </span>
                    Professional and affordable service. The survey reports were detailed and easy to understand.
                  </p>
                  <span
                    style={{
                      fontSize: "50px",
                      color: "#ffffffff",
                    }}
                  >
                    ”
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="why-choose-us-area rts-section-gap demo-1"
        style={{ paddingTop: "10px" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-center-style-one dark-title">
                <span class="pre">Your Questions, Answered</span>
                <h2 class="title">Frequently Asked Questions</h2>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-xl-6 col-lg-12 ">
              <div class="faq-inner-one">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item active">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Why should I choose a drone survey over a traditional survey?



                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Drone surveys can cover large areas quickly, show more details, and work safely in places that are hard to reach on foot.




                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What types of projects benefit from aerial surveys?


                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Aerial surveys are useful for land development, construction monitoring, topographic mapping, agricultural planning, environmental studies, and more.


                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        How long does an aerial survey take?

                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        The time depends on land size and project needs. Small plots can be surveyed in a few hours, while larger sites may take a day or more.


                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFive">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Is permission needed for drone surveys?

                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        In some areas, yes. We help with necessary flight permits and compliance with local drone regulations before the survey begins.

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Can aerial surveys work in rough or forested terrain?

                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Yes. Drones can fly above difficult ground and capture data that would be hard or risky to collect from the ground.


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-12 ">
              <div class="faq-inner-one " style={{ marginTop: "0px" }}>
                <div class="" data-aos="reveal-end"></div>
                <img src="assets/images/about/cta11-new.png" alt="journey-area" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AerialSurey;
